import { createFileRoute, Outlet } from '@tanstack/react-router';
import ObjectDetailPage from '@/pages/workspaces/objects/object-detail.page';
import { ObjectsMigrationRoute } from '@/pages/workspaces/objects/routing';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId')({
  component: () => (
    <ObjectsMigrationRoute>
      <ObjectDetailPage>
        <Outlet />
      </ObjectDetailPage>
    </ObjectsMigrationRoute>
  ),
});
